module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4lZsB"))).then(() => parcelRequire('d0iPb'));